import React from "react";
import { useSearchParams } from "react-router-dom";

export function useBatchFilters() {
  const [, setSearchParams] = useSearchParams();

  return React.useCallback(
    (updates: (params: URLSearchParams) => void) => {
      setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev);
        updates(newParams);
        return newParams;
      });
    },
    [setSearchParams]
  );
}
